import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["children", "disabled", "onClick", "task"];
import { useState } from 'react';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { LockedIcon } from 'foundations-assets';
import { useTaskApi } from '../../../hooks/task';
import ManualDetectedTaskButton from './ManualDetectedTaskButton';
import UsageLimitPopover from './UsageLimitPopover';
import { usePortalContactsLimit } from '../../../hooks/portalContacts';
import { Button } from 'foundations-components/transitional/components/Button';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const AddDataButton = _ref => {
  let {
      children,
      disabled,
      onClick,
      task
    } = _ref,
    buttonProps = _objectWithoutPropertiesLoose(_ref, _excluded);
  const [isUsageLimitPopoverOpen, setIsUsageLimitPopoverOpen] = useState(false);
  const {
    isWithinLimit,
    numberOfContacts,
    contactsLimit
  } = usePortalContactsLimit();
  const {
    checkAndCompleteTask
  } = useTaskApi();
  if (isWithinLimit) {
    return /*#__PURE__*/_jsx(ManualDetectedTaskButton, Object.assign({
      checkAndCompleteTask: checkAndCompleteTask,
      disabled: disabled,
      onClick: onClick,
      task: task
    }, buttonProps, {
      children: children
    }));
  }

  // We need to disable the 'open modal' functionality of ManualDetectedTaskButton
  // by using a regular UIButton here.
  return /*#__PURE__*/_jsx(UsageLimitPopover, {
    description: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "setup-guide-components.checklist.upgrade.contacts.description"
    }),
    onClose: () => setIsUsageLimitPopoverOpen(false),
    open: isUsageLimitPopoverOpen,
    planLimitLabel: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "setup-guide-components.checklist.upgrade.contacts.planLimit",
      options: {
        limitNumber: contactsLimit
      }
    }),
    planUsageLabel: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "setup-guide-components.checklist.upgrade.contacts.planUsage",
      options: {
        usedNumber: numberOfContacts,
        limitNumber: contactsLimit
      }
    }),
    taskKey: task.key,
    title: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "setup-guide-components.checklist.upgrade.contacts.title"
    }),
    upgradeCta: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "setup-guide-components.checklist.upgrade.contacts.upgradeCta"
    }),
    upgradeKey: "import-export-crm-contacts-limit",
    usageCurrent: numberOfContacts,
    usageLimit: contactsLimit,
    children: /*#__PURE__*/_jsxs(Button, Object.assign({
      onClick: () => {
        onClick === null || onClick === void 0 || onClick();
        setIsUsageLimitPopoverOpen(true);
      }
    }, buttonProps, {
      children: [/*#__PURE__*/_jsx(LockedIcon, {}), children]
    }))
  });
};
export default AddDataButton;